import { type INode } from '@shared/lib/ris.types'
import { type FunctionComponent } from 'react'
import Inline from '../Inline/Inline'
import * as styles from '../Clause.css'

const Paragraph: FunctionComponent<INode & { richRefLinks?: boolean }> = function Paragraph ({ richRefLinks, ...child }) {
  return (
    // Explicitly don't use className here and don't use <Text />. Set the styles via globalStyle() in Clause, to reduce file size in large laws
    <p>
      {child.marker && <span className={styles.marker}>{child.marker}</span>}
      <Inline {...child} skipInitialGldsym richRefLinks={richRefLinks} />
    </p>
  )
}

export default Paragraph
